
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { miscLinks, onboardingLink } from '../../../utils/internalLinks';
import { otpLength, } from '../../../utils/commonVariables';
import CloseIcon from '../../../assets/images/login/close.svg';
import { emailOtpVerification, emailVerification } from '../../../actions/login/register';
import {
  getTwoDigits, handleAuthState
} from "../../../utils/helper";
import { useEffect } from 'react';
import get from "lodash/get";
function SignupEmailOtpForm(props) {
  const [emailOtp, setEmailOtp] = useState(''),
    [emailOtpError, setEmailOtpError] = useState(''),
    [canResendOtp, setCanResendOtp] = useState(false),
    [otpMin, setOtpMin] = useState(1),
    [otpSeconds, setOtpSeconds] = useState(0);

  let timer = undefined;

  function resendOtpMail() {
    const { email, token } = props
    let dataToSend = {
      email: email,
      platform: "web"
    };
    setEmailOtpError("")
    setEmailOtp("")
    emailVerification(dataToSend, token).then((res) => {
      if (res && !get(res, "errors", []).length) {
        setOtpSeconds(0)
        setOtpMin(1)
        setCanResendOtp(false)
      } else {
        const errorMsg = get(res, "errors");
        if (errorMsg) {
          setEmailOtpError(errorMsg)
          setOtpSeconds(0)
          setOtpMin(1)
          setCanResendOtp(false)
        } else {
          setEmailOtpError("")
        }
      }
    });
  }
  function OtpVerify() {
    const { email, token, history } = props
    const data = {
      email,
      otp: emailOtp
    }
    const { emailOtpVerification } = props;
    emailOtpVerification(data, token, "login").then((val) => {
      if (val.data) {
        handleAuthState.add(token);
        history.replace({
          pathname: onboardingLink,
          state: {
            publicPageLink: props.publicPageLink || "",
          },
        });
      } else {
        setEmailOtpError(val.errors)
        setOtpSeconds(0)
        setOtpMin(1)
        setCanResendOtp(true)
      }
    })
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setOtpSeconds(
        otpSeconds === 0 && otpMin === 1
          ? 59
          : otpSeconds === 0 && otpMin === 0
            ? 0
            : otpSeconds - 1,
      );
      setOtpMin(otpSeconds === 0 && otpMin === 1 ? otpMin - 1 : otpMin);
      if (otpMin === 0 && otpSeconds === 0) {
        clearInterval(interval);
        setCanResendOtp(true);
        setEmailOtpError("")
      }
    }, 1000); // Interval set to 1000 milliseconds (1 second)

    // Clean up the interval when the component is unmounted
    return () => {
      clearInterval(interval);
    };
  }, [otpSeconds, otpMin])
  return (
    <div className="login-form">
      <div className="login-form__backdrop">
        <Link to={miscLinks.home} className="login-form__cancel">
          <img src={CloseIcon} alt="go to homepage" />
        </Link>
        <div className="login-form__container" style={{
          padding: "48px 27px"
        }}>
          <div className="login-form__header" style={{
            marginBottom: "12px"
          }}>
            <p className="login-form__title">Enter OTP</p>
          </div>
          <div>
            <p className="login-form__otp-form--confirm_title">
              Please confirm if this email belongs to you by entering the OTP sent to
              <span style={{
                color: "rgba(23,23,23,1)"
              }}> {props.email}</span></p>
            <div style={{
              padding: "12px 75px"
            }}>
              <div className="login-form__form__group">
                <input
                  type="number"
                  placeholder="OTP"
                  autoFocus={true}
                  value={emailOtp}
                  maxLength={otpLength}
                  onChange={(e) => {
                    setEmailOtp(e.target.value.slice(0, 6));
                    setEmailOtpError("")
                  }}
                  className="login-form__form__input1"
                  style={{
                    borderColor: emailOtpError ? "red" : null,
                    textAlign: "center",
                    color: emailOtpError ? "red" : "black",
                  }}
                />
                {emailOtpError && <p className="error-text" style={{
                  // marginBottom: "25px",
                  textAlign: "center",
                  position: "unset",
                  margin: "0px",
                  marginTop: "10px"
                }}>{emailOtpError}</p>}
                {(!emailOtpError || !canResendOtp) && <p className="login-form__otp-form--time">
                  0{otpMin}:{getTwoDigits(otpSeconds)}
                </p>}
              </div>
              <p className="login-form__otp-form--time">Didn’t receive the code? <button
                className="login-form__otp-form--resend_button" style={{
                  color: canResendOtp ? "rgba(73,144,226,1)" : "black",
                  opacity: canResendOtp ? null : "0.3"
                }} disabled={!canResendOtp} onClick={resendOtpMail}>Resend now</button></p>
              <button className="login-form__otp-form--continue_button" style={{
                backgroundColor: emailOtp.length < 6 ? "rgba(23,23,23,0.3)" : "black",
              }} disabled={emailOtp.length < 6} onClick={OtpVerify}>Continue</button>
              <div className="login-form__otp-form--update_email_div">
                <span className="login-form__otp-form--update_email"
                  onClick={props.toggleEmailForm}>Update email</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

SignupEmailOtpForm.propTypes = {
  token: PropTypes.string,
  email: PropTypes.string,
  toggleEmailForm: PropTypes.func,
  history: PropTypes.object,
};

export default connect(null, { emailOtpVerification })(SignupEmailOtpForm);
